import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';
import { usePlanFeatureGate } from '../../feature-gates/use-plan-feature-gate';
import { Features } from '../../constants/features';

export const usePickPackFeatureEnabled = () => {
  const flagEnabled = useFeatureFlag(FeatureFlagDeclarations.enablePickPackAccess);
  const basicPickSellerFeature = usePlanFeatureGate(Features.WarehouseMobileBasicPicking);
  const sellerFeatureEnabled = basicPickSellerFeature?.isFeatureEnabled;

  return flagEnabled || sellerFeatureEnabled;
};
